import {
    readUserText,
    resolveUserDisplayName,
    resolveUserUsername,
} from "./userIdentity";

const PLACEHOLDER_AUTHOR_NAMES = new Set([
    "unknown user",
]);

const readAuthorName = (...values) => {
    const text = readUserText(...values);
    if (!text || PLACEHOLDER_AUTHOR_NAMES.has(text.toLowerCase())) {
        return null;
    }
    return text;
};

export const resolveChatMessageAuthorName = ({
    message,
    resolveUserName,
    currentUserId,
    currentUser,
    fallback = "Unknown user",
} = {}) => {
    const senderId = message?.senderId === undefined || message?.senderId === null
        ? null
        : String(message.senderId).trim();
    const currentUserKey = currentUserId === undefined || currentUserId === null
        ? null
        : String(currentUserId).trim();

    if (senderId && currentUserKey && senderId === currentUserKey) {
        const selfName = readAuthorName(
            resolveUserDisplayName(currentUser),
            resolveUserUsername(currentUser)
        );
        if (selfName) {
            return selfName;
        }
    }

    const resolvedProfile = senderId && typeof resolveUserName === "function"
        ? resolveUserName(senderId)
        : null;
    const resolvedName = readAuthorName(
        resolveUserDisplayName(resolvedProfile),
        resolveUserUsername(resolvedProfile)
    );
    if (resolvedName) {
        return resolvedName;
    }

    return readAuthorName(
        resolveUserDisplayName(message?.sender),
        resolveUserUsername(message?.sender),
        resolveUserDisplayName(message),
        resolveUserUsername(message),
        message?.senderName,
        message?.author,
        message?.name
    ) || fallback;
};
